
const menuItems = [
  {
    title: 'Dashboard',
    icon: 'fa-solid fa-chart-line',
    roles: ['sudo', 'finance'],
    type: ['sudo', 'finance'],
    children: [
      { title: 'Dashboard', icon: 'fa-solid fa-chart-line', roles: ['sudo', 'finance'], type: ['sudo', 'finance'], path: '/dashboard' },
    ],
  },

  {
    title: 'Inicio',
    icon: 'fa-regular fa-tachometer-alt',
    roles: ['admin', 'sudo', 'owner', 'finance', 'business', 'client','partnerAdmin'],
    type: ['sudo','finance','partnerAdmin'],
    children: [
      { title: 'Donaciones', icon: 'fa-regular fa-heart', roles: ['admin','sudo','owner','finance','client',''], path: '/donaciones' },
      { title: 'Donaciones', icon: 'fa-regular fa-heart', roles: ['business','partnerAdmin'] , type: ['partnerAdmin','business'], path: '/partner/donaciones' },
      { title: 'Comentarios', icon: 'fa-regular fa-comment', roles: ['sudo','owner','business','partnerAdmin'], path: '/messages' },
    ],
  },

  {
    title: 'Campañas',
    icon: 'fa-regular fa-bullhorn',
    roles: [ 'sudo', 'owner', 'business','partnerAdmin'],
    type: ['partnerAdmin','sudo'],
    children: [

      { title: 'Campañas', icon: 'fa-solid fa-bullhorn', roles: ['partnerAdmin','business'], type: ['partnerAdmin','business'], path: '/partner/campaigns' },
      { title: 'Campañas', icon: 'fa-solid fa-bullhorn', roles: ['sudo'], type: ['sudo'], path: '/campaigns' },
      { title: 'Suscripciones', icon: 'fa-solid fa-bullhorn', roles: ['sudo'], type: ['sudo'], path: '/subscriptions/pixelpay' },
      { title: 'Push Notifications', icon: 'fa-solid fa-bell', roles: ['sudo'], type: ['sudo'], path: '/admin/push-notifications' },
    ],
  },

  {
    title: 'Organizaciones',
    icon: 'fa-regular fa-user',
    roles: [ 'sudo',],
    type: ['sudo'],
    children: [
      { title: 'Fundaciones', icon: 'fa-regular fa-building', roles: ['sudo'], type: ['sudo'], path: '/businesses' },
      { title: 'Marcas', icon: 'fa-regular fa-building', roles: ['sudo'], type: ['sudo'], path: '/brands' },
      { title: 'Activaciones', icon: 'fa-solid fa-bolt', roles: ['sudo'], type: ['sudo'], path: '/activations' },
    ],
  },
  {
    title: 'Organizaciones',
    icon: 'fa-regular fa-user',
    roles: ['partnerAdmin' , 'business',],
    type: ['partnerAdmin','business'],
    children: [
      { title: 'Mis Organizaciones', icon: 'fa-regular fa-building', roles: ['business','partnerAdmin'], path: '/partner/organizations' },

    ],
  },

  {
    title: 'Legal',
    icon: 'fa-regular fa-user',
    roles: ['sudo', 'legal'],
    type: ['sudo'],
    children: [
      { title: 'Contratos', icon: 'fa-solid fa-file-pdf', roles: ['legal','sudo'], type: ['sudo'], path: '/contracts' },
      // { title: 'Certificados', icon: 'fa-regular fa-file-contract', roles: ['admin','sudo','owner','business'], path: '/certificates' },
    ],
  },

  {
    title: 'Finanzas',
    icon: 'fa-regular fa-dollar-sign',
    roles: ['sudo', 'finance', 'business','partnerAdmin'],
    type: ['sudo','finance','partnerAdmin'],
    children: [
      {
        title: 'Retiros de fondos',
        icon: 'fa-solid fa-money-check-dollar',
        roles: ['sudo', 'finance', ],
        type: ['sudo','finance'],
        path: '/finance/retiro-de-fondos',

      },
      { title: 'Pendientes de pago', icon: 'fa-solid fa-money-bill-transfer', roles: ['sudo', 'finance'], type: ['sudo','finance'], path: '/finance/pendientes-de-pago' },
      { title: 'Reportes de pago', icon: 'fa-solid fa-money-bill-wave', roles: ['sudo', 'finance'], type: ['sudo','finance'], path: '/finance/reportes-pago' },
      { title: 'Solicitudes de retiros', icon: 'fa-solid fa-money-bill-transfer', roles: ['partnerAdmin','business'], type: ['partnerAdmin','business'], path: '/partner/PayoutsSolicitations' },
      { title: 'Reportes de pago', icon: 'fa-solid fa-money-bill-transfer', roles: ['partnerAdmin','business'], type: ['partnerAdmin','business'], path: '/partner/reportes-pago' },
      // { title: 'Reportes de pago', icon: 'fa-solid fa-money-bill-transfer', roles: ['sudo', 'finance'], type: ['sudo','finance'], path: '/partner/finance/reportes-pago' },

      // { title: 'Reportes financieros', icon: 'fa-solid fa-file-invoice', roles: ['admin','sudo', 'finance','owner','business'], path: '/finance/reportes-financieros' },
      // { title: 'Reportes Pago Impuesto', icon: 'fa-solid fa-file-invoice-dollar', roles: ['admin','sudo','owner','business'], path: '/finance/reportes-pago-impuesto' },
      // { title: 'Facturas', icon: 'fa-solid fa-file-invoice-dollar', roles: ['admin','sudo','finance','owner','business'], path: '/finance/facturas' },
    ],
  },

  {
    title: 'Usuarios',
    icon: 'fa-regular fa-user',
    roles: ['sudo', ],
    type: ['sudo'],
    children: [
      { title: 'Usuarios', icon: 'far fa-user-circle', roles: ['sudo'], type: ['sudo'], path: '/users' },
      { title: 'KYC onboarding', icon: 'fa-solid fa-user-check', roles: ['sudo'], type: ['sudo'], path: '/kyc/onboarding' },
      { title: 'Usuarios Administradores', icon: 'fa-regular fa-user', roles: ['sudo'], type: ['sudo'], path: '/usersAdmin' },
      { title: 'SMS OTP', icon: 'fa-regular fa-message', roles: ['sudo'], type: ['sudo'], path: '/smsOtp' },
    ],
  },

  {
    title: 'Configuración',
    icon: 'fa-regular fa-cog',
    roles: ['sudo'],
    type: ['sudo'],
    children: [
      { title: 'Países', icon: 'fas fa-globe-americas', roles: ['sudo'], type: ['sudo'], path: '/paises' },
      { title: 'Bitácora de accesos', icon: 'fa-regular fa-file-alt', roles: ['sudo'], type: ['sudo'], path: '/accessLogs' },
    ],
  },
];

export default {
  menuItems,
};
